import { joinPaths } from "node_modules/@astrojs/internal-helpers/dist/path";
import type { ImageTransform } from "node_modules/astro/dist/@types/astro";
import { isESMImportedImage } from "node_modules/astro/dist/assets/utils/imageKind";
import { isRemoteAllowed } from "node_modules/astro/dist/assets/utils/remotePattern";

export interface ImgTransform extends Omit<Omit<ImageTransform, "width">, "height"> {
  width?: string | number;
  height?: string | number;
  fit?: "cover" | "contain" | "fill" | "inside" | "outside";
  position?: "top" | "right top" | "right" | "right bottom" | "bottom" | "left bottom" | "left" | "left top";
}

const getURL = (options: ImgTransform):string|undefined => {
  const searchParams = new URLSearchParams();
  if(!options.src)
    return undefined;
  if (isESMImportedImage(options.src)) {
    searchParams.append("href", options.src.src);
  } else if (isRemoteAllowed(options.src, {
    domains: ["avepoint.com"],
    remotePatterns: [{
      protocol: "https"
    }]}
  )) {
    searchParams.append("href", options.src);
  } else {
    return options.src;
  }
  const params = {
    w: "width",
    h: "height",
    q: "quality",
    f: "format",
    fit: "fit",
    p: "position"
  };
  Object.entries(params).forEach(([param, key]) => {
    options[key] && searchParams.append(param, options[key].toString());
  });
  const imageEndpoint = joinPaths(import.meta.env.BASE_URL, "/_image");
  return `${imageEndpoint}?${searchParams}`;
}

export {
  getURL as default,
  getURL
};